module.exports = new __parcel__URL__("shadow-phrases-words.a0c431e4.jpg").toString();